export default class DatasetCategory {
  public id: number;
  public label = "";
  public description = "";
  public datasets_count = 0;
}
